import { Box, Card, CardContent, IconButton, Typography } from "@mui/material";
import { useStyle } from "@features/cart/components/BroadbandCard/BroadbandCartAddon/BroadbandCartAddonComponent/style";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { AddonCounter } from "@common/BroadbandAddon/AddonCounter/AddonCounter";
import { useDeviceType } from "@hooks/useDeviceType";
import { useTranslation } from "react-i18next";

interface IParams {
    maxQuantity: number;
    counter: number;
    description?: string;
    handleAddAddon(): void;
    handleRemoveAddon(): void;
    handleClearAddons(): void;
    isLoading: boolean;
}

export const BroadbandCartAddonCard = (props: IParams) => {
    const {
        maxQuantity,
        counter,
        description,
        handleAddAddon,
        handleRemoveAddon,
        handleClearAddons,
        isLoading,
    } = props;
    const { isMobile } = useDeviceType();
    const { classes } = useStyle({ isMobile });
    const { t } = useTranslation("cart", { keyPrefix: "broadband" });

    const addonCounterComponent = (
        <AddonCounter
            counter={counter}
            handleAddAddon={handleAddAddon}
            handleRemoveAddon={handleRemoveAddon}
            iconColor="primary"
            isLoading={isLoading}
            maxQuantity={maxQuantity}
        />
    );

    return (
        <Card elevation={2}>
            <CardContent className={classes.cardContent}>
                <Box display="flex" justifyContent="space-between" width="100%">
                    <Typography className={classes.title} noWrap variant="h2">
                        {description ?? t("cartBroadbandAddon.addonName")}
                    </Typography>
                    <Box display="flex" gap={1} justifyContent="flex-end">
                        {!isMobile && addonCounterComponent}
                        <IconButton
                            aria-label="delete-broadband-addons-button"
                            className={`${classes.deleteButton} ${classes.deleteButtonSize}`}
                            disabled={isLoading}
                            onClick={handleClearAddons}
                        >
                            <DeleteIcon className={classes.deleteButtonIcon} />
                        </IconButton>
                    </Box>
                </Box>
                {isMobile && addonCounterComponent}
            </CardContent>
        </Card>
    );
};
